// extracted by mini-css-extract-plugin
export var active = "swich-module--active--AsU4l";
export var mobile_display = "swich-module--mobile_display--ZHKzz";
export var swich_link = "swich-module--swich_link--JE7bk";
export var switcher = "swich-module--switcher--wCvF-";